import View from "./view";
import {Button, Modal} from "antd";
import React, {useState} from "react";

const ViewParent = ({visible, id, name, onCancel, databaseKey}) => {

    const [exportData, setExportData] = useState(false)
    const [exportDataMerge, setExportDataMerge] = useState(false)
    const [data, setData] = useState(true)
    const footer = () =>{
        return (
            <>
                <Button key="back"  onClick={()=>onCancel()} >
                    Hủy
                </Button>
                <Button key="submit"
                        type="primary"
                        style={{color: "white"}}
                        onClick={()=>setExportData(true)}>
                    Tạo báo cáo
                </Button>
                {
                    data &&
                    <Button key="submitReport"
                            type="primary"
                            style={{color: "white"}}
                            onClick={()=>setExportDataMerge(true)}>
                        Hợp nhất và Tạo báo cáo
                    </Button>
                }
            </>
        )
    }
    return (
        <Modal visible={visible}
               width={800}
               onCancel={() => onCancel()}
               title={<h3 style={{padding: "0 24px 24px 0", margin : 0}}> {name} </h3>}
               bodyStyle={{
                   minHeight: 100,
                   maxHeight: 600,
               }}
               destroyOnClose={true}
               footer={footer()}
               closable={false} >
            <View id={id}
                  name={name}
                  databaseKey={databaseKey}
                  exportData={exportData}
                  exportDataMerge={exportDataMerge}
                  onExportData={()=>setExportData(false)}
                  onExportDataMerge={()=>setExportDataMerge(false)}
                  onData={(value)=>setData(value?.length>0)}
            />
        </Modal>
    )
}

export default ViewParent
